import { makeStyles } from '@material-ui/core/styles';
import {
  buttonIconStyle,
  primaryButtonStyle,
  secondaryButtonStyle,
} from '../shared/styles/buttons.styles';
import { redesignTheme } from '../theme';

const { colors, fonts, fontSize, spacing, breakpoints } = redesignTheme;

export const useErrorPageStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 72px)',
    padding: spacing.md,
    textAlign: 'center',
    boxSizing: 'border-box',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.md,
    maxWidth: 737,
    width: '100%',
  },
  errorCode: {
    margin: 0,
    fontFamily: fonts.gothicBold,
    fontSize: 120,
    color: colors.primaryDark,
    lineHeight: 'normal',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: 80,
    },
  },
  title: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.xxl,
    color: colors.textBody,
    lineHeight: 'normal',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.xl,
    },
  },
  description: {
    margin: 0,
    maxWidth: 624,
    fontFamily: fonts.opensans,
    fontSize: fontSize.lg,
    color: colors.textBody,
    lineHeight: 'normal',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.base,
    },
  },
  actions: {
    display: 'flex',
    gap: spacing.sm,
    flexWrap: 'wrap',
    justifyContent: 'center',
    width: '100%',
    maxWidth: 480,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      flexDirection: 'column',
      maxWidth: '100%',
    },
  },
  btnPrimary: {
    ...primaryButtonStyle,
    flex: 1,
    whiteSpace: 'nowrap',
  },
  btnSecondary: {
    ...secondaryButtonStyle,
    flex: 1,
    whiteSpace: 'nowrap',
  },
  btnHelp: {
    ...secondaryButtonStyle,
    color: colors.primary,
    width: '100%',
    maxWidth: 480,
    whiteSpace: 'nowrap',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      maxWidth: '100%',
    },
  },
  btnIcon: {
    ...buttonIconStyle,
  },
}));
